import { CustomFormattedMessage } from '../../../../i18n/i18n';
import { TransactionItemTable } from './TransactionItemTable';
import { AmountRows } from './AmountRows';
import { Transaction, weaklyDisplayMonetaryAmounts } from '../../../../models';

type DeliveredAmountsOverviewProps = {
  transaction: Transaction;
};

export const DeliveredAmountsOverview = ({
  transaction,
}: DeliveredAmountsOverviewProps) => {
  const hasItems = transaction.items.length > 0;

  return (
    <>
      {(hasItems || transaction.deliveryAmount) && (
        <h6 className="padding-left-10 margin-top-20">
          <CustomFormattedMessage id="common.transaction.notInvoiced" />
        </h6>
      )}
      {hasItems &&
        transaction.items.map((item, index) => {
          return (
            <TransactionItemTable
              item={item}
              key={index}
              transactionState={transaction.state}
            />
          );
        })}
      {transaction.deliveryAmount && (
        <table className="table table-condensed">
          <colgroup>
            <col className="width-150" />
            <col />
          </colgroup>
          <tbody>
            <AmountRows
              netLabel={'common.transaction.totalPriceNet'}
              grossLabel={'common.transaction.totalPriceGross'}
              amount={transaction.deliveryAmount}
              weaklyDisplayAmounts={weaklyDisplayMonetaryAmounts(
                transaction.state,
              )}
              highlightLabel
            />
          </tbody>
        </table>
      )}
    </>
  );
};
